import React, { useEffect, useState } from "react";
import Card from "components/Card/Card";
import axios from "axios";
import apiUrl from "../../../variables/api";

import { toast } from "react-toastify";

import {
  Text,
  Flex,
  FormControl,
  FormLabel,
  Input,
  FormErrorMessage,
  Button,
  Textarea,
  RadioGroup,
  Stack,
  SimpleGrid,
  AbsoluteCenter,
  Center,
  useColorMode,
  Skeleton,
  Table,
  Thead,
  Tbody,
  Tfoot,
  Tr,
  Th,
  Td,
  TableCaption,
  TableContainer,
} from "@chakra-ui/react";
import { Field, Form, Formik } from "formik";
import CustomCheckbox from "../../../components/Checkbox/CustomCheckbox";

function Page() {
  const { colorMode } = useColorMode();
  const [vehicles, setVehicles] = useState([]);
  const [loading, setLoading] = useState({});

  useEffect(() => {
    console.log(colorMode);
    axios
      .get(apiUrl + "/data/vehicles", {
        headers: { "x-access-token": localStorage.getItem("token") },
      })
      .then((response) => {
        console.log(response.data);
        if (response.data.length !== 0) {
          setVehicles(response.data);
        }
      })
      .catch((error) => {
        console.error(error);
        toast.error("Napotkano błąd podczas połączenia z API");
      });
  }, []);

  const handleWithdraw = (id) => {
    setLoading((prev) => ({ ...prev, [id]: true }));
    axios
      .put(
        apiUrl + "/data/vehicles/withdraw",
        { id, operationalNumber: vehicles.find((vehicle) => vehicle.id === id).operationalNumber },
        {
          headers: { "x-access-token": localStorage.getItem("token") },
        }
      )
      .then((response) => {
        console.log(response.data);
        if (response.data.success) {
          setVehicles(
            vehicles.map((vehicle) => {
              if (vehicle.id === id) {
                vehicle.disabled = true;
              }
              return vehicle;
            })
          );
          toast.success("Pojazd został wycofany");
        }
      })
      .catch((error) => {
        console.error(error);
        toast.error("Napotkano błąd podczas wycofywania pojazdu");
      })
      .finally(() => {
        setLoading((prev) => ({ ...prev, [id]: false }));
      });
  };

  const handleRestore = (id) => {
    setLoading((prev) => ({ ...prev, [id]: true }));
    axios
      .put(
        apiUrl + "/data/vehicles/restore",
        { id, operationalNumber: vehicles.find((vehicle) => vehicle.id === id).operationalNumber },
        {
          headers: { "x-access-token": localStorage.getItem("token") },
        }
      )
      .then((response) => {
        console.log(response.data);
        if (response.data.success) {
          setVehicles(
            vehicles.map((vehicle) => {
              if (vehicle.id === id) {
                vehicle.disabled = false;
              }
              return vehicle;
            })
          );
          toast.success("Pojazd został przywrócony");
        }
      })
      .catch((error) => {
        console.error(error);
        toast.error("Napotkano błąd podczas przywracania pojazdu");
      })
      .finally(() => {
        setLoading((prev) => ({ ...prev, [id]: false }));
      });
  };

  const Withdraw = ({ id }) => (
    <Button
      colorScheme="red"
      size="sm"
      onClick={() => handleWithdraw(id)}
      isLoading={loading[id]}
    >
      Wycofaj
    </Button>
  );

  const Restore = ({ id }) => (
    <Button
      colorScheme="green"
      size="sm"
      onClick={() => handleRestore(id)}
      isLoading={loading[id]}
    >
      Przywróć
    </Button>
  );

  return (
    <Flex flexDirection="column" pt={{ base: "120px", md: "75px" }}>
      <Card minH="125px">
        <TableContainer>
          <Table variant="stripped" colorScheme="gray">
            <Thead>
              <Tr>
                <Th>Jednostka</Th>
                <Th>Pojazd</Th>
                <Th>Wycofany</Th>
                <Th></Th>
              </Tr>
            </Thead>
            <Tbody>
              {vehicles?.map((vehicle, index) => (
                <Tr
                  key={vehicle.id}
                  backgroundColor={
                    index % 2 == 0
                      ? colorMode == "dark"
                        ? "gray.600"
                        : "gray.200"
                      : "transparent"
                  }
                >
                  <Td>{vehicle.unit}</Td>
                  <Td>{vehicle.operationalNumber}</Td>
                  <Td>{vehicle.disabled ? "TAK" : "NIE"}</Td>
                  <Td>
                    {!vehicle.disabled ? (
                      <Withdraw id={vehicle.id} />
                    ) : (
                      <Restore id={vehicle.id} />
                    )}
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </TableContainer>
      </Card>
    </Flex>
  );
}

export default Page;
